export const getFirstPartOfPathname = (pathname: string) =>
  pathname.split('/')[1];
